<template>
	<div id="app">
		<div id="wrapper" v-if="$route.name != 'step_one' && $route.name != 'step_two' && $route.name != 'step_three'">
			<left-nav v-if="$route.name != 'step_one' && $route.name != 'step_two' && $route.name != 'step_three'"/>
			<div id="content-wrapper" class="rightSidebar d-flex flex-column content-wrapper"> 
				<app-header :pageTxt1="pageTxt" v-if="$route.name != 'step_one' && $route.name != 'step_two' && $route.name != 'step_three'"/>
				<router-view />
			</div>
		</div>
			<router-view v-if="$route.name == 'step_one' || $route.name == 'step_two' || $route.name == 'step_three'" />
	</div>
</template>

<script>
	import leftNav from './shared/left-nav'
	import header from './shared/header'
// Vue.component('app-header', header)
	import * as types from '@/types'
	import { mapActions } from 'vuex'
	export default {
		name: 'App',
		data() {
			return {
				pageTxt: '',
			}
		},
		 components: {
		 	leftNav,
		 	AppHeader : header
		},
		methods:{
			...mapActions({
				_runstateLoad: types.RUN_STATE_LOAD,
				_runLogout: types.RUN_LOGOUT
			}),
			logout(){
				let input_json={
					'globalParams' :{},
					'localParams' :{ "parameter" : this }
				}
				this._runLogout(input_json)
			}
		},
		created(){
			this._runstateLoad({'globalParams' :{},'localParams' :{ "parameter" : this }})
			this._runGetMedicineList({ 'globalParams' : {},'localParams' : { 'parameter' : this } });
		}

		
	}
</script>


// WEBPACK FOOTER //
// src/components/website/index.vue